import classNames from 'classnames';
import React, { useContext, useEffect } from 'react';
import {
  BorderAll,
  BorderClear,
} from '@styled-icons/material';
import styles from '../../styles/Home.module.css';
import { isXRayHotkey } from '../../sharedComponents/TextEditor/commands/hotkeys';
import Tooltip from '../../sharedComponents/TextEditor/components/Tooltip';
import { XRayModeContext, XRayModeDispatchContext } from '../../sharedComponents/TextEditor/context/XRayModeContextProvider';
import useCmdCtrl from '../../sharedComponents/TextEditor/utils/useCmdCtrl';

function XRayModeToggle() {
  // ==== Add X-Ray Mode to see boundaries ====
  const xRayMode = useContext(XRayModeContext);
  const setXRayMode = useContext(XRayModeDispatchContext);
  const symbol = useCmdCtrl();

  useEffect(() => {
    function keydownXRay(event: KeyboardEvent) {
      if (isXRayHotkey(event)) {
        event.preventDefault();
        setXRayMode(!xRayMode);
      }
    }
    document.addEventListener('keydown', keydownXRay);
    return () => {
      document.removeEventListener('keydown', keydownXRay);
    };
  }, [xRayMode]);
  // ==== Add X-Ray Mode to see boundaries ====

  return (
    <Tooltip center="X-Ray Mode" right={`${symbol} K`}>
      <div
        className={classNames(styles.navbarItemButton, {
          [styles.navbarItemButtonSelected]: xRayMode,
        })}
        onClick={() => setXRayMode((prevMode) => !prevMode)}
        role="none"
      >
        <span
          className={classNames('is-size-7', {
            'with-light-text-color': !xRayMode,
            'with-accent-text-color': xRayMode,
          })}
        >
          {xRayMode ? (
            <BorderAll size={18} style={{ marginRight: 5 }} />
          ) : (
            <BorderClear size={18} style={{ marginRight: 5 }} />
          )}
          X-Ray Mode
        </span>
      </div>
    </Tooltip>
  );
}

export default XRayModeToggle;
